<template>
	<div class="central content flex flex-align-start">
		<div class="flex-1 mr40">
			<div>
				<div class="el-page-header" style="line-height: 30px;">
					<div class="el-page-header__left" @click="goBack">
						<i class="el-icon-back"></i>
						<div class="el-page-header__title">返回</div>
					</div>
					<div class="el-page-header__content">
						{{data.title}}
						<span @click="getFxLink" style="color: #75aef8;cursor: pointer;margin-left: 10px;">
							<el-image class="share" :src="require('@/static/share.png')" fit="cover"></el-image>
							<span style="margin-left: 4px;font-size: 16px;">点击复制素材链接</span>
						</span>
					</div>
				</div>
			</div>
			<!-- <div>
				<el-page-header @back="goBack" :content="data.title"></el-page-header>
			</div> 
			<div style="float: right;position: relative;top: -25px;">
				<el-tooltip class="item" effect="dark" content="获取分享链接" placement="top">
					<span style="cursor: pointer;" @click="getFxLink">
						<el-image class="share" :src="require('@/static/share.png')" fit="cover"></el-image>
					</span>
				</el-tooltip>
			</div> -->
			<div style="min-height: 300px;padding: 5px 0 50px 10px; margin-top: 20px; width: 70%;" v-loading="isLoading">
				<div class="rich-text line-break" v-html="data.content || ''"></div>
				<div v-if="fileList.length>0" class="image-grid">
					<!--加载图片-->
					<el-image 
						v-for="(item,index) in fileList" 
						:key="index" 
						class="square-image"
						:src="item" 
						:preview-src-list="fileList"
						fit="cover">
					</el-image>
				</div>
			</div>
		</div>
		
		<!-- 宣传图 -->
		<el-carousel class="border-radius-10" style="width: 360px;" trigger="click" :interval="5000" arrow="never" height="480px">
			<el-carousel-item v-for="(item,index) in swiper" :key="index">
				<el-image style="width: 360px;height: 480px;" :src="item.image" fit="cover"></el-image>
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
import { EventBus } from '@/main.js'
export default {
	name: 'Targeted',
	data(){
		return{
			kkey:'',
			data:[],
			fileList:[],
			retryMaxTimes: 10, // 最大重试次数
    		retryCurrentTimes: 0, // 当前重试次数
			momentNoticeId: this.$route.query.id
		}
	},
	mounted(){
		EventBus.$emit('router-path', this.$route.path)
		
		if(this.token) this.getUser()
		
		this.getDataKey(this.momentNoticeId)
	},
	methods: {
		getFxLink(){
			let url = window.location.href
			const prefixEndIndex = url.indexOf('#/') + 2;
  			const targetPrefix = url.slice(0, prefixEndIndex)+'friendContentH5?kkey='+this.kkey;
			this.$copyText(targetPrefix).then(e => {
				this.$message.success('复制素材链接成功')
			}, function (e) {
				this.$message.error('复制素材链接失败')
			})
		},
		async getDataKey(momentNoticeId){
			this.isLoading = true
			this.$http.post('/api/webs/search/buildSysMoment', { momentNoticeId: momentNoticeId })
			.then(response => {
				let res = response.data
				if(res!=null){
					this.kkey = res.kkey
					this.getData(res.kkey);
				} else {
					this.isLoading = false
				}
			})
			.catch(error => {
				console.error(error)
				this.isLoading = false
			})
		},
		async getData(kkey){
			if (this.retryCurrentTimes >= this.retryMaxTimes) {
				this.isLoading = false;
				this.$message.error(`重试${this.retryMaxTimes}次后仍失败，请稍后再试`);
				return;
			}
			let params = {
				kkey: kkey,
			}
			this.$http.get('/api/webs/search/getCacheSysMoment', { params })
			.then(response => {
				if(response.code=='B000005'){
					this.retryCurrentTimes++; // 累加重试次数
					setTimeout(() => {
						this.getData(kkey);
					}, 2000);
					return;
				}
				let res = response.data
				this.isLoading = false
				if(res!=null){
					this.data = res
					this.fileList = JSON.parse(res.file)
				}
			})
			.catch(error => {
				this.retryCurrentTimes++;
				console.error(error)
				this.isLoading = false
			})
		},
		goBack(){
			this.$router.go(-1)
		}
	}
}
</script>

<style>
.share{
	width: 20px;
	position: relative;
	top: 5px;
}
.el-descriptions-item__label.is-bordered-label{
	width: 140px !important;
}
/* 图片网格布局：实现3列换行 + 均匀间距 */
.image-grid {
  display: flex;          /* 弹性布局 */
  flex-wrap: wrap;        /* 自动换行（核心：实现3个一行） */
  gap: 15px;              /* 图片之间的间距（替代margin，更简洁） */
  margin: 10px 0;         /* 上下外边距 */
}

/* 正方形图片核心样式：3列均分 */
.square-image {
  width: calc(33.333% - 10px); /* 3列 - 间距补偿（gap=15px，每列减去10px） */
  aspect-ratio: 1 / 1;    /* 宽高1:1，正方形 */
  box-sizing: border-box; /* 避免padding/border影响宽度 */
}

/* 强制el-image内部容器填满正方形 */
.square-image >>> .el-image__inner {
  width: 100% !important;
  height: 100% !important;
}

/* 关键：解析\n为换行 */
.line-break {
  white-space: pre-line; 
  /* 可选：补充行高，提升可读性 */
  line-height: 1.8;
}
</style>